export const levelColors: Record<string, string> = {
  Starfish: '#ff94ca',
  Seahorse: '#fff056',
  Seal: '#88fa4e',
  Barracuda: '#55c1ff',
  Swordfish: '#ff968d',
  Dolphin: '#d31876',
  Shark: '#d31876',
};

// Chip palette for the 7 SOF levels: a readable text color plus a light
// background tint, both kept in the same hue family as the level badge so the
// chip's text/background visually match the badge icon.
export const levelChipColors: Record<string, string> = {
  Starfish: '#d6337f',
  Starfish_BG: '#ffe3f1',
  Seahorse: '#a68a00',
  Seahorse_BG: '#fffacc',
  Seal: '#4e9e1f',
  Seal_BG: '#e2fbd0',
  Barracuda: '#0a7fc2',
  Barracuda_BG: '#d6f0ff',
  Swordfish: '#e0554a',
  Swordfish_BG: '#ffe0dc',
  Dolphin: '#d31876',
  Dolphin_BG: '#fbd4e6',
  Shark: '#374151',
  Shark_BG: '#e5e7eb',
};

export const levelAlternativeColors: Record<string, string> = {
  Development: '#102E50',
  Purple: '#522546',
  Bronze: '#706D54',
  Silver: '#818C78',
  Silber: '#818C78',
  Gold: '#EFB036',
  Elite: '#EB5A3C',
};

export const levelAlternativeChipColors: Record<string, string> = {
  Development: '#102E50',
  Development_BG: '#e0e8f2',
  Purple: '#522546',
  Purple_BG: '#f0dce8',
  Bronze: '#706D54',
  Bronze_BG: '#eee9d8',
  Silver: '#5f6b5d',
  Silver_BG: '#e8eee5',
  Silber: '#5f6b5d',
  Silber_BG: '#e8eee5',
  Gold: '#9a6800',
  Gold_BG: '#fff0c2',
  Elite: '#b33e21',
  Elite_BG: '#ffe2d9',
};

export const serviceColors: Record<string, string> = {
  TICKET: '#5a3286',
  TICKET_BG: '#e6cff2',
  COURSE: '#215a6c',
  COURSE_BG: '#c6dbe1',
  PROGRAM: '#155bad',
  PROGRAM_BG: '#bfe1f6',
  HIRESPACE: '#11734b',
  HIRESPACE_BG: '#d4edbc',
};
// export const serviceColors: Record<string, string> = {
//   TICKET: '#102E50',
//   COURSE: '#FF9B17',
//   PROGRAM: '#E78B48',
//   HIRESPACE: '#BE3D2A',
// };

export const serviceTypeColors: Record<string, string> = {
  SOF: '#0a53a8',
  SOF_BG: '#bfe1f6',
  'FLYING FISH': '#5a3286',
  'FLYING FISH_BG': '#e6cff2',
  'ADULT COURSES': '#6b164b',
  'ADULT COURSES_BG': '#c491b0',
  'ADULT COURSES_UNLIMITED': '#6b164b',
  'ADULT COURSES_UNLIMITED_BG': '#c491b0',
  'PRIVATE LESSON': '#0f6d63',
  'PRIVATE LESSON_BG': '#c7ede7',
};

export const userTypeColors: Record<string, string> = {
  CHILD: '#bc1e1d',
  CHILD_BG: '#ffcfc9',
  ADULT: '#884c17',
  ADULT_BG: '#ffc8aa',
};

export const trialStatusColors: Record<string, string> = {
  ENROLL: '#11734b',
  ENROLL_BG: '#d4edbc',
  PENDING: '#6b7280',
  PENDING_BG: '#e5e7eb',
  NOT_COME: '#bc1e1d',
  NOT_COME_BG: '#ffcfc9',
};

export const assessmentMonthColors: Record<string, string> = {
  JAN: '#2563eb',
  FEB: '#7c3aed',
  MAR: '#db2777',
  APR: '#dc2626',
  MAY: '#ea580c',
  JUN: '#ca8a04',
  JUL: '#65a30d',
  AUG: '#059669',
  SEP: '#0d9488',
  OCT: '#0891b2',
  NOV: '#0284c7',
  DEC: '#4f46e5',
};

export const genderColors: Record<string, string> = {
  MALE: '#1976d2',
  MALE_BG: '#bbdefb',
  FEMALE: '#d81b60',
  FEMALE_BG: '#f8bbd0',
  OTHER: '#7b1fa2',
  OTHER_BG: '#e1bee7',
};
